var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-overlay',{attrs:{"show":_vm.isShow,"custom-style":{
                background: 'rgb(0, 0, 0, 0.6)',
                display: 'flex',
                justifyContent: 'center',
                paddingTop: '70%',
            }}},[_c('van-loading',{attrs:{"size":"24px","color":"#ffffff"}},[_c('span',{staticStyle:{"color":"#ffffff"}},[_vm._v(_vm._s(_vm.title || "加载中···"))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }